import Bg from "./Bg";
import Loading from "./Loading";
import KvCarousel from "./KvCarousel";
import TechnologyPreview from "./TechnologyPreview";
import Projects from "./Projects";
import Message from "./Message";
import Last from "./Last";
import ResetAndGo from "./ResetAndGo";
import Transition from "./Transition";
import Space from "./Space";
import About from "./About";

const init = () => {
  //背景
  new Bg();

  //KVカルーセル
  const carousel = new KvCarousel();

  //Aboutエリア
  // new About();

  //RESET AND GO
  new ResetAndGo();

  //TECHNOLOGYのプレビュー画像
  new TechnologyPreview();

  //PROJECTSエリア
  new Projects();

  //LASTメッセージ
  new Last();

  //宇宙エリア
  new Space();

  //フェードインするMessage生成
  document.querySelectorAll(".js-message").forEach((elm) => {
    new Message(elm);
  });

  //トランジション初期化
  Transition.init();

  //ローディング
  const loading = new Loading();
  loading.on("COMPLETE", () => {
    carousel.start();
  });

  //ブラウザバック
  window.onpageshow = function (event) {
    if (event.persisted) {
      Transition.hide();
    }
  };

  //リンクはトランジションを挟むaタグ
  document.querySelectorAll("a").forEach(($a) => {
    const href = $a.getAttribute("href");
    const target = $a.getAttribute("target");
    if (target != "_blank") {
      $a.addEventListener("click", (e) => {
        e.preventDefault();
        Transition.show(href);
      });
    }
  });
};

export { init };
